import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormGroup, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatTableDataSource } from '@angular/material/table';
import { DialogService } from 'src/app/services/dialog.service';
import { HTTPService } from 'src/app/services/http.service';
import { FormulaTesterComponent } from '../../formula-tester/formula-tester.component';
import { Subscription, debounceTime } from 'rxjs';

@Component({
    selector: 'data-save-configuration',
    templateUrl: './data-save-configuration.component.html',
    styleUrls: ['./data-save-configuration.component.scss'],
    standalone: false
})
export class DataSaveConfigurationComponent implements OnInit, OnDestroy {
  variables: any[];

  ignoreStatus = false;
  ignoreMessage = false;
  ignoreResponse = false;
  ignoreRequest = false;
  selectedRow: any;
  openpa = false;
  opensr = false;
  sub1:Subscription;
  sub2:Subscription;
  sub3:Subscription;

  constructor( private formBuilder:UntypedFormBuilder, private http:HTTPService,
    private dialogServices:DialogService) { }

 
formGroup:FormGroup<any>;
@Input() stepDataSave:FormGroup<any>
conditionSearch = ` EXISTS (SELECT 1 FROM Mktpdiccol c where  c.idinstance  = entityPrincipal.idinstance and c.columnname = 'CODECOMPANY')`;
columns: MatTableDataSource<any> = null;
//displayedColumns: string[] = ['desc', 'field', 'type', 'filter',  'df'];
displayedColumns: string[] = ['desc', 'field', 'type',  'df'];


  ngOnDestroy(){
      if ( this.sub1 != null){ this.sub1.unsubscribe();} 
      if ( this.sub2 != null){ this.sub2.unsubscribe();} 
      if ( this.sub3 != null){ this.sub3.unsubscribe();} 
  }

  onSelectTable(){
    
  }
  

  ngOnInit(): void {
    
    this.formGroup = this.formBuilder.group({
        idInstance: new UntypedFormControl(null,[Validators.required]),
        'idInstance->INSTANCENAME':  new UntypedFormControl(null),
        filter: new UntypedFormControl(null,[Validators.required]),
        ignoreMessage: new UntypedFormControl(null),
        ignoreStatus: new UntypedFormControl(null),
        ignoreResponse: new UntypedFormControl(null),
        ignoreRequest: new UntypedFormControl(null),
        
    });
  
    this.sub3 = this.formGroup.get('idInstance').valueChanges.subscribe(idInstance=>{
      this.loadColumns(idInstance);
    });


    this.loadTableName().then(data=>{
        if ( this.formGroup.get('idInstance').value != null ){
          let idInstance  = this.formGroup.get('idInstance').value
          this.loadColumns(idInstance).then(d=>{
            this.loadSaveResponseFields();
          });
        }
    });

    this.sub2 = this.formGroup.valueChanges.pipe(debounceTime(1000)).subscribe(data=>{
          this.setTableName();
          //this.setSaveResponseFields();

    });
      
  }

  setSaveResponseFields(){
      let object = [];
      if (this.columns!= null ){
        this.columns.data.forEach(data=>{
          if ( data['formula']!= null  && data['formula']!=''){
              let srf = {};
              srf['name'] = data['COLUMNNAME'];
              srf['formula'] = data['formula'];
              object.push(srf);
          }
        });
      
        this.stepDataSave.get('SAVERESPONSEFIELDS').setValue(JSON.stringify(object));
      }
      
  }

  changeValueFormula(){
      this.setSaveResponseFields();
  }

  setTableName(){
      
      let tableName = '';
      Object.keys(this.formGroup.controls).forEach(control=>{
        const abstractControl = this.formGroup.controls[control];  
        if ( control!='idInstance->INSTANCENAME'){
          if ( abstractControl.value!=null ){
            if ( tableName == ''){
              tableName = tableName + control+":"+abstractControl.value;  
            }else{
              tableName = tableName+';' + control+":"+abstractControl.value;
            }
            
          }
        }

        if ( control=='idInstance->INSTANCENAME'){
          if(abstractControl.value!= null  ){
            if  ( tableName == ''){
              tableName = tableName + "entityName:"+abstractControl.value;
            }else{
              tableName = tableName+';' + "entityName:"+abstractControl.value;
            } 
          }  
        }

        
      });

      if( tableName =='' || tableName == null){
        this.stepDataSave.get('TABLENAME').setValue(null,{onlySelf:true, emitEvent:false});
      }else{
        this.stepDataSave.get('TABLENAME').setValue(tableName,{onlySelf:true, emitEvent:false});
      }
      
  }

  loadSaveResponseFields(){
      let object:Object[] = JSON.parse(this.stepDataSave.get('SAVERESPONSEFIELDS').value);
      if (object != null ){
        object.forEach( data => {
          let name = data['name'];
          let formula = data['formula'];
          this.columns.data.find(d=>d['COLUMNNAME']==name)['formula'] = formula;
        });
        this.opensr = true;  
      }
      
  }

  loadTableName(){

    return new Promise((resolve,reject)=>{
      let tableName:string = this.stepDataSave.get('TABLENAME').value;
      if ( tableName == null || tableName==''){
          resolve(true);
          return;
      }
  
      let params:string[] = tableName.split(';');
      for ( var p of params ){
         let keyValue = p.split(':');

         let key = keyValue[0];
         let value = keyValue[1];
  
         if ( key =='entityName'){
          this.formGroup.get('idInstance->INSTANCENAME').setValue(value);  
         }else{
          this.formGroup.get(key).setValue(value);
         }
         
         if ( key.startsWith('ignore')){
            if ( value == 'N'){
                this[key] = false;
            }else{
              this[key] = true;
              this.openpa = true;  
            }
         }
      }
      resolve(true);
    });
  }

  set filter(value){
    this.formGroup.get('filter').setValue(value);
  }

  get filter(){
    return this.formGroup.get('filter');
  }

  openEditFormula(column){
    this.variables = [];    
    this.dialogServices.openGenericDialog(FormulaTesterComponent,{formula:column.formula, variables:this.variables},(f)=>{
        if ( f['formula']){
          column.formula = f['formula'];
        }
        
    },()=>{},'80vh','80vw',false,null,'S','80px');
  }


  loadColumns(idInstance){

    return new Promise((resolve,reject)=>{
      let obinfo = {
        "entityName":"Mktpdiccol",
        "sql":`SELECT COLUMNNAME, DATATYPE, COLUMNDESC, ISPK, COLSIZE FROM Mktpdiccol (nolock) WHERE IDINSTANCE=${idInstance} ORDER BY ISPK DESC,COLUMNNAME`
      }         
          
      this.sub1 = this.http.post(obinfo,'JsonBrokerServices/findnative',false,true,true).subscribe(conInfo=>{
        let info =  conInfo['SQL'];
        let data = info.map(column => ({ ...column,  formula: ''}));
        this.columns = new MatTableDataSource(data);
        resolve(true);
      });
    });
    
  }


  onToggleChange(evento:MatSlideToggleChange ,column){
  
    let value = 'N';
    if ( evento.checked ){
        value = 'S';
    }
    this.formGroup.get(column).setValue(value);
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.columns.filter = filterValue.trim().toLowerCase();
  }

  changeEventoFilter(evento){
    
  }

  selectRow(row){
    this.selectedRow = row;
  }
}
